import React from 'react';
import { useEffect } from 'react';
const About = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <section style={{marginTop:'20%'}} className="page-title-alt bg-primary position-relative">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h1 className="text-white font-tertiary">About </h1>
                        </div>
                    </div>
                </div>
                {/* background shapes */}
                <img
                    src="images/illustrations/leaf-bg-top.png"
                    alt="illustrations"
                    className="bg-shape-1 w-100"
                />
                <img
                    src="images/illustrations/dots-group-sm.png"
                    alt="illustrations"
                    className="bg-shape-2"
                />
                <img
                    src="images/illustrations/leaf-yellow.png"
                    alt="illustrations"
                    className="bg-shape-3"
                />
                <img
                    src="images/illustrations/leaf-orange.png"
                    alt="illustrations"
                    className="bg-shape-4"
                />
                <img
                    src="images/illustrations/dots-group-cyan.png"
                    alt="illustrations"
                    className="bg-shape-5"
                />
                <img
                    src="images/illustrations/leaf-cyan-lg.png"
                    alt="illustrations"
                    className="bg-shape-6"
                />
            </section>
            {/* /page title */}
            {/* about */}
            <section className="section pt-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8">
                            <p>
                                Our movie platform is designed for film lovers who want to explore a world full of entertainment, excitement, and unforgettable stories. We provide a wide collection of movies from different genres including action, adventure, romance, and drama. Whether you are looking for the latest releases or timeless classics, our website makes it easy to discover films that match your taste.
                            </p>
                            <p>
                                Our mission is to bring cinema closer to everyone. We believe movies are more than just entertainment — they inspire, educate, and connect people around the world. Through our platform, we aim to build a community of movie enthusiasts who share the same passion for storytelling and creativity.
                            </p>
                            <p>
                                We focus on delivering a smooth and enjoyable browsing experience. Users can search for movies, filter by category, and view detailed information about each film. Our goal is to create a simple and modern interface that allows visitors to quickly find what they want without complications. Every movie is carefully displayed with high-quality images and organized sections.
                            </p>
                        </div>
                        <div className="col-md-4 text-center drag-lg-top">
                            <div className="shadow-down mb-4">
                                <img
                                    src="https://t3.ftcdn.net/jpg/05/90/75/40/360_F_590754013_CoFRYEcAmLREfB3k8vjzuyStsDbMAnqC.jpg"
                                    alt="author"
                                    className="img-fluid w-100 rounded-lg border-thick border-white"
                                />
                            </div>
                            <h4 style={{letterSpacing:'1px',fontSize:'40px'}}>Movie Hub</h4>
                        </div>
                    </div>
                </div>
            </section>
            {/* /about */}
            {/* Work Process */}
            <section className="section">
                <div className="container">
                    <div className="row justify-content-around">
                        <div className="col-lg-12 text-center">
                            <h2 className="section-title">Work Process</h2>
                        </div>
                        <div className="col-lg-3 col-md-4 text-center hover-shadow pt-3">
                            <div className="">
                                <img src="images/icons/plan.png" className="mb-4" alt="icon" />
                                <h4 className="mb-4">Design </h4>
                                <p>
يتميز موقعنا بتصميم عصري وسهل الاستخدام يتيح للزوار تصفح الأفلام بسرعة وسلاسة.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 text-center hover-shadow pt-3">
                            <img src="images/icons/design.png" className="mb-4" alt="icon" />
                            <h4 className="mb-4">Diversity</h4>
                            <p>
يتميز موقعنا بتنوع كبير في الأفلام بين الأكشن والرومانسية والمغامرات والدراما لتناسب جميع الأذواق.
                            </p>
                        </div>
                        <div className="col-lg-3 col-md-4 text-center hover-shadow pt-3">
                            <img src="images/icons/print.png" className="mb-4" alt="icon" />
                            <h4 className="mb-4">Search easily</h4>
                            <p>
يتميز موقعنا بإمكانية البحث والفلترة الذكية التي تساعد المستخدمين على العثور على أفلامهم المفضلة بسهولة.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            {/* ./Work Process */}
            {/* team */}
            <section
                className="section bg-cover"
                data-background="images/backgrounds/team-bg.png"
            >
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h3 className="section-title">The website was created by:</h3>
                        </div>
                        <div className="col-md-4 col-sm-6 mb-4 mb-md-0">
                            <div className="card text-center">
                                <img src="images/team/member-1.png" className="card-img-top" />
                                <div className="card-body">
                                    <h4 className="card-title">Jack Schenziwe</h4>
                                    <p className="text-light font-secondary">Project Manager</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-6 mb-4 mb-md-0">
                            <div className="card text-center">
                                <img src="images/team/member-2.png" className="card-img-top" />
                                <div className="card-body">
                                    <h4 className="card-title">Jack Schenziwe</h4>
                                    <p className="text-light font-secondary">Project Manager</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-6 mb-4 mb-md-0">
                            <div className="card text-center">
                                <img src="images/team/member-3.png" className="card-img-top" />
                                <div className="card-body">
                                    <h4 className="card-title">Jack Schenziwe</h4>
                                    <p className="text-light font-secondary">Project Manager</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* /team */}
            {/* clients */}
            <section className="section">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h2 className="section-title">My Clients</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="client-logo-slider d-flex align-items-center">
                                <a
                                    href="contact.html"
                                    className="text-center d-block outline-0 p-4"
                                >
                                    <img
                                        className="d-unset img-fluid"
                                        src="images/clients-logo/client-logo-1.png"
                                        alt="client-logo"
                                    />
                                </a>
                                <a
                                    href="contact.html"
                                    className="text-center d-block outline-0 p-4"
                                >
                                    <img
                                        className="d-unset img-fluid"
                                        src="images/clients-logo/client-logo-2.png"
                                        alt="client-logo"
                                    />
                                </a>
                                <a
                                    href="contact.html"
                                    className="text-center d-block outline-0 p-4"
                                >
                                    <img
                                        className="d-unset img-fluid"
                                        src="images/clients-logo/client-logo-3.png"
                                        alt="client-logo"
                                    />
                                </a>
                                <a
                                    href="contact.html"
                                    className="text-center d-block outline-0 p-4"
                                >
                                    <img
                                        className="d-unset img-fluid"
                                        src="images/clients-logo/client-logo-4.png"
                                        alt="client-logo"
                                    />
                                </a>
                                <a
                                    href="contact.html"
                                    className="text-center d-block outline-0 p-4"
                                >
                                    <img
                                        className="d-unset img-fluid"
                                        src="images/clients-logo/client-logo-5.png"
                                        alt="client-logo"
                                    />
                                </a>
                                <a
                                    href="contact.html"
                                    className="text-center d-block outline-0 p-4"
                                >
                                    <img
                                        className="d-unset img-fluid"
                                        src="images/clients-logo/client-logo-1.png"
                                        alt="client-logo"
                                    />
                                </a>
                                <a
                                    href="contact.html"
                                    className="text-center d-block outline-0 p-4"
                                >
                                    <img
                                        className="d-unset img-fluid"
                                        src="images/clients-logo/client-logo-2.png"
                                        alt="client-logo"
                                    />
                                </a>
                                <a
                                    href="contact.html"
                                    className="text-center d-block outline-0 p-4"
                                >
                                    <img
                                        className="d-unset img-fluid"
                                        src="images/clients-logo/client-logo-3.png"
                                        alt="client-logo"
                                    />
                                </a>
                                <a
                                    href="contact.html"
                                    className="text-center d-block outline-0 p-4"
                                >
                                    <img
                                        className="d-unset img-fluid"
                                        src="images/clients-logo/client-logo-4.png"
                                        alt="client-logo"
                                    />
                                </a>
                                <a
                                    href="contact.html"
                                    className="text-center d-block outline-0 p-4"
                                >
                                    <img
                                        className="d-unset img-fluid"
                                        src="images/clients-logo/client-logo-5.png"
                                        alt="client-logo"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>

    );
}

export default About;

